/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Unpaid_InvoicesInputs */

const en_admin_dashboard_unpaid_invoices = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpaid Invoices`)
};

const de_admin_dashboard_unpaid_invoices = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbezahlte Rechnungen`)
};

const es_admin_dashboard_unpaid_invoices = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturas por pagar`)
};

const fr_admin_dashboard_unpaid_invoices = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factures non payées`)
};

const it_admin_dashboard_unpaid_invoices = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatture non pagate`)
};

const pt_br2_admin_dashboard_unpaid_invoices = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faturas não pagas`)
};

const pl_admin_dashboard_unpaid_invoices = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niezapłacone faktury`)
};

const hu_admin_dashboard_unpaid_invoices = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kifizetetlen számlák`)
};

const ro_admin_dashboard_unpaid_invoices = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturi Neplatite`)
};

/**
* | output |
* | --- |
* | "Unpaid Invoices" |
*
* @param {Admin_Dashboard_Unpaid_InvoicesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_unpaid_invoices = /** @type {((inputs?: Admin_Dashboard_Unpaid_InvoicesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Unpaid_InvoicesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_unpaid_invoices(inputs)
	if (locale === "de") return de_admin_dashboard_unpaid_invoices(inputs)
	if (locale === "es") return es_admin_dashboard_unpaid_invoices(inputs)
	if (locale === "fr") return fr_admin_dashboard_unpaid_invoices(inputs)
	if (locale === "it") return it_admin_dashboard_unpaid_invoices(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_unpaid_invoices(inputs)
	if (locale === "pl") return pl_admin_dashboard_unpaid_invoices(inputs)
	if (locale === "hu") return hu_admin_dashboard_unpaid_invoices(inputs)
	return ro_admin_dashboard_unpaid_invoices(inputs)
});
export { admin_dashboard_unpaid_invoices as "admin.dashboard.unpaid_invoices" }